import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    event: String,
    properties: Object
  }

  sendEvent(e) {
    if (!e.analyticsFinished) {
      e.preventDefault()

      const data = this.propertiesValue

      if (e.target.nodeName === "FORM") {
        const formData = new FormData(e.target)
        formData.forEach(function(value, key){
          data[key] = value
        })
      }

      this._sendToDataLayer(e, this.eventValue, data)
    }
  }

  _sendToDataLayer(e, event, data) {
    window.dataLayer.push({
      'event': event,
      ...data,
      'eventCallback' : function() {
        const newEvent = new e.constructor(e.type, e)
        // let the browser continue with the normal behavior of the clicked element
        newEvent.analyticsFinished = true
        e.target.dispatchEvent(newEvent)
      },
      'eventTimeout' : 2000
    })
  }
}
